import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import App from './App';
import { NetworkStatusProvider } from './shared/contexts/NetworkStatusContext';
import { LoaderProvider } from './shared/contexts/LoaderContext';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <NetworkStatusProvider>
    <LoaderProvider>
        <App />
      </LoaderProvider>

    </NetworkStatusProvider>
  </Provider>
);